import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=ce795f2e&scoped=true&"
import script from "./receipt.vue?vue&type=script&lang=js&"
export * from "./receipt.vue?vue&type=script&lang=js&"
import style0 from "./receipt.vue?vue&type=style&index=0&id=ce795f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce795f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce795f2e')) {
      api.createRecord('ce795f2e', component.options)
    } else {
      api.reload('ce795f2e', component.options)
    }
    module.hot.accept("./receipt.vue?vue&type=template&id=ce795f2e&scoped=true&", function () {
      api.rerender('ce795f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/receipt.vue"
export default component.exports